import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-dialog-conferma',
    imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent],
    templateUrl: './dialog-conferma.component.html',
    styleUrl: './dialog-conferma.component.css'
})
export class DialogConfermaComponent {
  data = inject(MAT_DIALOG_DATA);

  onSend() {
    this.dialogRef.close("Ok");
  }

  constructor(
    private dialogRef: MatDialogRef<DialogConfermaComponent>) {


  }
}